export { default } from './Others.component';
